// Примечание переводчику: Сохраняйте деловой нейтральный стиль, женский род для артиста, не переводите отраслевые термины
// (GoGo, Crazy menu и т.п.), а также плейсхолдеры вида {count} и текст в кавычках — от них зависят интерфейс и форматирование.
export const pages = {
  auth: {
    login: {
      title: 'Вход'
    },
    confirmation: {
      title: 'Подтверждение почты',
      description:
        'Мы отправили вам письмо с кодом на почту {email}. Отправка может занять до одной минуты'
    },
    verifyEmail: {
      title: 'Изменение пароля'
    },
    reset: {
      title: 'Изменение пароля'
    },
    otp: {
      title: 'Подтверждение почты',
      description:
        'Мы отправили вам письмо с кодом на почту {email}. Отправка может занять до одной минуты'
    },
    register: {
      title: 'Регистрация {role}а'
    },
    invite: {
      title: 'Добро пожаловать в Live Bright Connect',
      description: 'Выберите ваш вариант профиля'
    }
  },
  notification: {
    title: 'Уведомления',
    notFound: 'У вас пока нет уведомлений.',
    description:
      'Новые заявкаи от артистов вы можете просмотреть в разделе “Артисты” в вашем профиле'
  },

  loyalty: {
    inputLabel: 'Ваша ссылка:',
    registered: 'Зарегистрировались',
    followed_link: 'Прошли по ссылке',
    inputDescription:
      'Чтобы пригласить артистку, отправьте ссылку для регистрации.',
    artist: {
      title: 'Приглашение на сайт',
      description:
        'Приглашенной считается артистка, завершившая регистрацию по вашей ссылке.'
    },
    club: {
      title: 'Программа лояльности',
      note: 'Приглашенной считается артистка, завершившая регистрацию по вашей ссылке.',
      description: 'Получайте артисток без комиссии!',
      text: '👯‍♀️ У вас был кастинг, и артистка не подошла? Кто-то завершает контракт? Отправьте ей свою персональную ссылку.',
      content:
        'Когда артистка регистрируется по вашей ссылке, она засчитывается вам .📌 За каждые 5 артисток вы получаете 1 контракт без комиссии — на 1 календарный месяц.Даже если артистка выберет другой клуб — она всё равно будет учтена в ваш счётчик.‼️ Чтобы участвовать в программе, ваш клуб должен заполнить профиль и быть видимым в поиске.⚡ Делитесь ссылкой, развивайте платформу — и получайте выгоду уже сейчас.'
    }
  },

  language: {
    title: 'Языки',
    description: 'Выберите язык платформы',
    options: {
      ru: 'Русский',
      en: 'Английский',
      uk: 'Украинский',
      it: 'Итальянский',
      de: 'Немецкий',
      tr: 'Турецкий',
      es: 'Испанский'
    }
  },

  profilePage: {
    techSupport: 'Служба заботы',
    privacy: 'Условия и конфиденциальность',
    artist: {
      work: 'Работа в клубе',
      infoEditSection: 'Редактирование',
      infoAppSection: 'Приложение',
      personalInfo: 'О себе',
      portfolio: 'Портфолио',
      invitationAndRequests: 'Заявки и приглашения',
      hideProfile: 'Скрыть аккаунт',
      loyaltyLink: 'Пригласить друга'
    },
    club: {
      clubInfoSection: 'Информация клуба',
      artistsSection: 'Артисты',
      artistHiring: 'Набор артистов',
      loyaltyProgram: 'Программа лояльности',
      editingSection: 'Редактирование',
      clubInfo: 'О клубе',
      conditions: 'Условия',
      approvedArtists: 'Одобренные артисты',
      requestsAndInvitations: 'Заявки и приглашения',
      applicationSection: 'Приложение'
    }
  },
  portfolioPage: {
    title: 'Портфолио',
    warnNotPublished:
      'Резюме не опубликовано. Заполните портфолио, чтобы опубликовать резюме.',
    warnfillPortfolio: 'Заполните портфолио',
    warnf: 'Заполните портфолио',
    warnFillSection:
      'Заполните эту секцию, чтобы повысить шансы на приглашение.'
  },
  profileInfo: {
    club: {
      title: 'О клубе'
    },

    artist: {
      title: 'О себе'
    }
  },
  clubTerms: {
    title: 'Условия',
    description:
      'Постарайтесь полностью заполнить все шаги. От этого зависит привлекательность объявления для артисток. Обращайтесь за помощью если возникли трудности.',
    progressSteps: {
      schedule: 'График работы клуба',
      contractTerms:
        'Минимальный срок контракта, график артистов, билеты, трансфер из аэропорта',

      payments:
        'Выплаты: ставка, гарантия, фул, топлес, го-го, депозит, шоу, чай, консумация, крейзи меню',
      workConditions:
        'Тип консумации. Хореограф. Фотосессии. Пилоны. Количество',
      housing: 'Информация о жилье. Фото.',
      penalties: 'Штрафная сетка',
      photo: 'Фото клуба',
      video: 'Видео клуба'
    }
  },
  clubEmployers: {
    title: 'Одобренные артисты',
    tabs: {
      pending: 'В ожидании',
      onContract: 'На контракте'
    }
  },
  requestAndInvitation: {
    title: 'Заявки и приглашения'
  },
  onboarding: {
    club: {
      schedule: {
        title: 'Часы работы клуба',
        popups: {
          title: 'Часы работы'
        },
        changeAllWorkTimes: 'Изменить все часы работы'
      },
      contractTerms: {
        title: 'Условия работы в клубе',
        form: {
          minimalContractTerm: {
            label: 'Минимальный срок контракта',
            unit: 'Недели'
          },
          artistsSchedule: {
            label: 'График работы артистов'
          }
        }
      },
      payments: {
        title: 'Выплаты',
        rateFieldDescription:
          'Если у вас ставка одним числом, заполните только одно из полей ввода'
      },
      workConditions: {
        title: 'Условия работы в клубе',
        form: {
          noExperienceEmployment: 'Трудоустройство артисток без опыта',
          additionalInfo: {
            label: 'Дополнительная информация о клубе',
            placeholder:
              'Можете написать об акциях или бонусах в вашем клубе или другой информацию, которая будет интересна артистам',
            description: 'Введите не менее 100 символов'
          }
        },
        popups: {
          dressCode: {
            enterDressCodeElement: 'Введите элемент дресс кода',
            description:
              ' Выберите дресс код для артистов в вашем клубе. Добавьте отсутсвующие позиции.'
          }
        }
      },
      housing: {
        title: 'Информация о жилье'
      },
      penalties: {
        title: 'Штрафы',
        description:
          'Добавьте свои позиции, если не нашли их в предоставленном списке'
      },
      photo: {
        title: 'Фото клуба',
        description:
          'Загрузите фотографии клуба. Позже вы сможете внести изменения',
        options: {
          hallNoGuests: 'Фото пустого зала',
          hallWithGuests: 'Фото зала с гостями',
          privateRooms: 'Фото приватных комнат',
          scene: 'Фото сцены'
        }
      },
      video: {
        title: 'Видео клуба',
        description: 'Загрузите видео клуба. Позже вы сможете внести изменения',
        options: {
          ClubTour: 'Видео пустого зала',
          EventVideo: 'Видео зала с гостями',
          WorkingHours: 'Видео сцены'
        }
      }
    },
    artist: {
      work: {
        title: 'Опыт работы',
        addWorkPlace: 'Добавить место работы',
        notHaveWorkExperience: 'Продолжить без опыта'
      },
      language: {
        title: 'Языки',
        languageProfinience: 'Владение иностранными языками'
      },
      parametres: {
        title: 'Параметры'
      },
      about: {
        title: 'О себе',
        description: 'Напишите о себе то что будет интересно клубу',
        textAreaDescription: 'Введите не менее 100 символов',
        textAreaPlaceholder: 'Введите'
      },
      video: {
        title: 'Видео',
        videoForHostesVacancy: '2. Загрузите видео проходку',
        videoForGogoVacancy:
          '1. Загрузите видео, как вы танцуете для вакансии стрип танцовщицы и го-го'
      },
      photo: {
        title: 'Фото',
        description:
          'Загрузите фотографии. Фотографии должны быть без фильтров и фотошопа.',
        FaceNoMakeup: 'Модель - лицо без макияжа.',
        FaceWithMakeup: 'Лицо / Мейкап.',
        FreePose: 'Фото модели в свободной позе.',
        FullBodyOnHeels: 'Фото модели во весь рост на каблуках.',
        LingerieOrSwimsuit: 'Фото модели в купальнике',
        selectMainPhoto: 'Выбрать главное фото'
      }
    }
  },
  workInteraction: {
    club: {
      artistHaveContract: 'Артист уже работает в клубе',
      incompleted:
        'Чтобы отправлять приглашения, вы должны заполнить свой профиль на 100%.'
    },
    artist: {
      weCanRequestLastWorkDate:
        'Запросите дату завершения контракта у клуба.',
      clubSetLastWorkDate:
        'Клуб установил вашу последнюю дату работы в этом клубе.',
      clubNotHiring:
        ' Вы не можете отправлять запрос, так как клуб не открыл набор артистов.',
      pendingRequest:
        'Вы не можете отправлять более одного запроса в течение 48 часов.',
      haveContract:
        ' Вы не можете отправить запрос, так как у вас есть действующий контракт .',
      hidden:
        'Вы не можете отправить запрос, так как ваш профиль скрыт из поиска.',
      incompleted:
        'Вы не можете отправить запрос, так как вы не заполнили профиль полностью.'
    }
  },
  notFoundWorkItem: {
    title: 'Это приглашение или запрос больше не существует.',
    description:
      'Мы сожалеем, но страницы не существует. Пожалуйста, перейдите наглавную.'
  },
  notFoundCurrentWork: {
    title: 'Hет активного контракта',
    description:
      'В данный момент у вас нет активного контракта, перейдите на страницу поиска и отправьте заявку в клуб, чтобы начать контракт.'
  },
  clubFullProfile: {
    clubVideo: 'Видео клуба',
    clubPhoto: 'Фото клуба',
    clubHousingPhoto: 'Фото жилья',
    minimalContractDuration: 'Минимальный контракт, недели',
    artistWorkSchedule: 'График работы',
    paymentFrequescyMessage: 'Выплаты артисту за консумацию — 1 раз в'
  },
  privacyPolicy: {
    title: 'Пользовательское соглашение и политика конфиденциальности'
  },
  chat: {
    requestSupport: {
      inviteManagerInChat: 'Пригласить менеджера в чат',
      managerIsInChat: 'Менеджер в чате',
      manageRequestPending: 'Менеджер скоро присоеденится'
    },
    admin: {
      assistanceProvided: 'Помощь оказана',
      openDirectChat: 'Открыть личный чат',
      openWhatsApp: 'Открыть WhatsApp',
      phoneNumberNotAvailable: 'Номер телефона недоступен'
    }
  }
};
